import React from 'react';
import { Note } from '../../Note';
import { ExternalLink } from '../../../PageElements/ExternalLink';
import { Text } from '../../../PageElements/Text';

// we should get this from the server this shouldnt be hard coded!!
const PERMISSIONS_MAP = {
  'WIX_STORES.MODIFY_ORDERS': 'Wix Stores > Modify Orders',
  'WIX_STORES.READ_ORDERS': 'Wix Stores > Read Orders',
};

const toHumanFormat = (permission) => PERMISSIONS_MAP[permission] || permission;

export const PermissionsNote = ({ permissions, isEvent }) => {
  return (
    <Note title="Permissions">
      <Text dataHook="permissions-text">
        {`This ${
          isEvent ? 'webhook' : 'endpoint'
        } requires the ${generatePermissionsText()}`}{' '}
        <ExternalLink to="https://devforum.wix.com/en/article/available-permissions">
          permission scope
        </ExternalLink>
        .
      </Text>
    </Note>
  );

  function generatePermissionsText() {
    return permissions.reduce((acc, curr, index) => {
      if (curr && typeof curr !== 'boolean' && curr.name) {
        if (index < permissions.length - 1) {
          acc += `${toHumanFormat(curr.name)} or the `;
        } else {
          acc += toHumanFormat(curr.name);
        }
      }
      return acc;
    }, '');
  }
};
